import { MapPin, Phone } from "lucide-react";
import { PHONE_DISPLAY, PHONE_HREF, SERVICE_AREA } from "@/lib/contact";

export const ServiceArea = () => {
    return (
        <section
            id="service-area"
            data-testid="section-service-area"
            className="py-10 md:py-14"
        >
            <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
                <div
                    data-testid="service-area-strip"
                    className="tp-reveal relative overflow-hidden rounded-3xl bg-tp-forest text-white p-6 md:p-10 border border-tp-forest/60"
                >
                    <div
                        className="absolute -top-16 -right-16 w-[360px] h-[360px] rounded-full pointer-events-none"
                        style={{
                            background:
                                "radial-gradient(closest-side, rgba(232,185,35,0.28), rgba(232,185,35,0) 70%)",
                        }}
                    />
                    <div className="relative grid gap-6 md:grid-cols-[1.4fr,1fr] items-center">
                        <div>
                            <div className="inline-flex items-center gap-2 rounded-full bg-white/10 border border-white/15 px-3 py-1.5 text-xs uppercase tracking-[0.18em] text-tp-gold">
                                <MapPin size={14} strokeWidth={2.4} className="text-tp-gold" />
                                Service area
                            </div>
                            <h2 className="mt-3 font-heading text-3xl md:text-4xl leading-tight">
                                Proudly servicing all of {SERVICE_AREA.split(",")[0]}
                            </h2>
                            <p className="mt-3 text-sm md:text-base text-white/85 max-w-xl">
                                From the CBD to the outer suburbs — Inner West, Eastern
                                Suburbs, Northern Beaches, North Shore, Sutherland Shire,
                                Hills District, South West and Western Sydney. If you’re in
                                Sydney, we’ve got a bin for you.
                            </p>
                        </div>
                        <div className="flex flex-col gap-3 md:items-end">
                            <a
                                href={PHONE_HREF}
                                data-testid="service-area-call-button"
                                className="tp-btn-primary text-base h-12 px-5 tp-focus"
                            >
                                <Phone size={18} strokeWidth={2.6} />
                                Call {PHONE_DISPLAY}
                            </a>
                            <a
                                href="#quote"
                                data-testid="service-area-quote-button"
                                className="tp-btn-outline text-sm h-11 px-4 tp-focus"
                            >
                                Or get a written quote
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default ServiceArea;
